module.exports = __webpack_public_path__ + "static/img/fred_logo.7c04c01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fred_logo.png
// module id = ZpdA
// module chunks = 1